/* @flow */

import { Map } from 'immutable';

import {
  SHIPPING_METHODS_REQUEST,
  SHIPPING_METHODS_FETCH_SUCCESS,
  SHIPPING_METHODS_FETCH_FAILURE,
} from './action';

const initialState = Map({
  type: '',
  payload: Map({}),
});

function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === SHIPPING_METHODS_REQUEST) {
    const { payload, loading } = action;
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => loading).setIn(['payload'], Map({}));
  }

  if (type === SHIPPING_METHODS_FETCH_SUCCESS) {
    const { payload, loading } = action;
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => loading).setIn(['payload'], Map(payload));
  }

  if (type === SHIPPING_METHODS_FETCH_FAILURE) {
    const { payload, loading } = action;
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => loading).setIn(['payload'], Map(payload));
  }

  return state;
}

export default reducer;
